import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import css from './TimeZone.scss';
import preferenceCss from './PreferencesSection.scss';
import Switch from 'common/Switch';
import { basicTimeZones, timeZones } from 'utils/timeZones';
import Select from 'common/StyledSelect';
import { find } from 'lodash';

/**
 * @returns {node} the component for users to set their time zone
 */
const TimeZone = ({ setValue, timeZone }) => {
    const [displayAllTimeZones, setDisplayAllTimeZones] = useState(false);
    const [options, setOptions] = useState([]);
    
    useEffect(() => {
        // if a non-basic time zone was previously chosen by the user, it needs to appear in the basic list
        // that is shown on the initial load of the page without having to select "display all time zones"
        if (!displayAllTimeZones && !basicTimeZones.find(zone => zone.value === timeZone)) {
            setOptions([
                ...basicTimeZones,
                timeZones.find(zone => zone.value === timeZone)
            ]);
        } else {
            setOptions(displayAllTimeZones ? timeZones : basicTimeZones);
        }
    }, [displayAllTimeZones]);
    
    return (
        <div id="timezone-section">
            <label htmlFor="timeZone">Time Zone</label>
            <Select id="timeZone"
                    ariaLabel="Time Zone"        
                    className={css['timezone-dropdown']}                     
                    onChange={newTimeZone => setValue({timeZone: newTimeZone.value})}
                    options={options}
                    value={find(options, ['value', timeZone])} />
            <span className={`${preferenceCss['profile-adv-options']} ${preferenceCss['profile-sub-text']}`}>
                Time zone not listed?
            </span>
            <div className={css['display-all']}>
                <Switch aria-labelledby="displayAllTimeZones"
                        checked={displayAllTimeZones}
                        onChange={(checked) => {
                            setDisplayAllTimeZones(checked);
                        }} />
                <label id="displayAllTimeZones">Display all time zones</label>
            </div>
        </div>
    )
};

TimeZone.propTypes = {
    setValue: PropTypes.func.isRequired,
    timeZone: PropTypes.string
};

export default TimeZone;
